import api from "../../services/api";
import { Business } from "./types";

// ✅ Fetch all businesses
export const searchBusinesses = async (params: {
  query?: string;
  lat?: number;
  lng?: number;
}) => {
  const res = await api.get<Business[]>("/businesses", { params });
  return res.data;
};

// ✅ Fetch business details by ID
export const fetchBusinessDetailsAPI = async (id: string): Promise<Business> => {
  const response = await api.get<Business>(`/business/${id}`);
  return response.data;
};
